import uuid from 'uuid/v1';

export default [
  {
    id: uuid(),
    product: 'موز',
    disciple: 'حسین اسدی',
    q: 4,
    totalPrice:4500
  },
  {
    id: uuid(),
    product: 'تخم مرغ',
    disciple: 'امیرجواد افروغ',
    q: 2,
    totalPrice:1900
  },
];
